/**
 * Toast Module - Simple notification toasts
 */

let toastContainer = null;
let activeToast = null;
let hideTimeout = null;

/**
 * Initialize toast container
 */
export function initToast() {
  if (toastContainer) return;

  toastContainer = document.createElement("div");
  toastContainer.id = "toast-container";
  toastContainer.className = "toast-container";
  document.body.appendChild(toastContainer);
}

/**
 * Show a toast notification
 * @param {string} message - Message to display
 * @param {Object} options - Options
 * @param {string} options.type - 'info' | 'warning' | 'error' | 'success'
 * @param {number} options.duration - Duration in ms (default 3000)
 */
export function showToast(message, options = {}) {
  const { type = "info", duration = 3000 } = options;

  // Ensure container exists
  if (!toastContainer) {
    initToast();
  }

  // Clear existing toast
  if (activeToast) {
    activeToast.remove();
    activeToast = null;
  }
  if (hideTimeout) {
    clearTimeout(hideTimeout);
    hideTimeout = null;
  }

  // Create toast element
  const toast = document.createElement("div");
  toast.className = `toast toast-${type}`;

  // Icon based on type
  const icons = {
    info: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>`,
    warning: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>`,
    error: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>`,
    success: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>`,
  };

  const iconSpan = document.createElement('span');
  iconSpan.className = 'toast-icon';
  iconSpan.innerHTML = icons[type] || icons.info;
  const msgSpan = document.createElement('span');
  msgSpan.className = 'toast-message';
  msgSpan.textContent = message;
  toast.appendChild(iconSpan);
  toast.appendChild(msgSpan);

  toastContainer.appendChild(toast);
  activeToast = toast;

  // Trigger animation
  requestAnimationFrame(() => {
    toast.classList.add("toast-visible");
  });

  // Auto-hide
  hideTimeout = setTimeout(() => {
    hideToast();
  }, duration);
}

/**
 * Hide the current toast
 */
function hideToast() {
  if (!activeToast) return;

  activeToast.classList.remove("toast-visible");
  activeToast.classList.add("toast-hiding");

  setTimeout(() => {
    if (activeToast) {
      activeToast.remove();
      activeToast = null;
    }
  }, 300);
}
